import { Link } from "react-router-dom";
import RichContent from "@/components/RichContent";
import { useQuery } from "@tanstack/react-query";
import { FileText, ShieldCheck } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";
import api from "@/lib/api";

export default function LegalPage({ type, fallbackTitle }) {
  const { data: agreements = [] } = useQuery({ queryKey: ["agreements"], queryFn: () => api.get("/agreements").then((r) => r.data) });
  const doc = agreements.find((a) => a.type === type);
  const title = doc?.title || fallbackTitle;

  return (
    <div data-testid={`legal-${type}-page`}>
      <Seo title={title} description={`${title} for Enhancing Your World — how we handle your information, bookings and the terms of participation.`} />
      <PageHero label="Trust & Compliance" title={title} subtitle="Enhancing Your World — how we handle your information and the terms of participation." testid={`legal-${type}-hero`} />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <div className="flex flex-wrap gap-3 mb-8">
          <Link to="/privacy" className="eyw-btn-ghost !py-2 text-sm"><ShieldCheck size={15} /> Privacy Policy</Link>
          <Link to="/terms" className="eyw-btn-ghost !py-2 text-sm"><FileText size={15} /> Terms of Service</Link>
          <Link to="/cancellation" className="eyw-btn-ghost !py-2 text-sm">Cancellation Policy</Link>
          <Link to="/refunds" className="eyw-btn-ghost !py-2 text-sm">Refund Policy</Link>
          <Link to="/policies" className="eyw-btn-ghost !py-2 text-sm">All policies</Link>
        </div>
        {doc ? (
          <article className="eyw-card p-8">
            <h2 className="font-serif text-2xl text-[#1A242B] mb-4 flex items-center gap-2"><FileText size={20} className="text-[#144F75]" /> {doc.title}</h2>
            <RichContent text={doc.content} className="text-sm text-[#4A5D6B] leading-relaxed" testid={`legal-${type}-content`} />
            {doc.version != null && <p className="text-xs text-[#8FA89B] mt-6">Version {doc.version}</p>}
          </article>
        ) : (
          <p className="text-sm text-[#4A5D6B]">This policy is being finalized. Please check back shortly or contact us.</p>
        )}
        <p className="text-xs text-[#8FA89B] pt-6">Contact: hello@enhancingyourworld.com</p>
      </section>
    </div>
  );
}
